define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'index2024-athomeandpro/component/page-content',

    // 'WebCommon/init'
], function(
    Vue,
    i18n,
    PageMixin,

    PageContent
){
    var app = new Vue({
        mixins: [PageMixin],
        components: {
            PageContent: PageContent
        },
        i18n: i18n
    });
    app.$mount('#app');

});



//////////////////
// WEBPACK FOOTER
// ./index2024-athomeandpro/main.js
// module id = 369
// module chunks = 9